import React, { useState, useEffect } from "react";

const CheckboxWithLabel = ({ label, checked: externalChecked, onChange: externalOnChange, disabled = false }) => {
  const [isChecked, setIsChecked] = useState(externalChecked || false);

  useEffect(() => {
    if (externalChecked !== undefined) {
      setIsChecked(externalChecked);
    }
  }, [externalChecked]);

  const toggleCheckbox = () => {
    if (externalOnChange) {
      externalOnChange(!isChecked);
    } else {
      setIsChecked((prev) => !prev);
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <input
        type="checkbox"
        className="h-5 w-5 text-primary focus:ring-primary border-gray-300 rounded cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        checked={isChecked}
        onChange={toggleCheckbox}
        disabled={disabled}
      />
      <label className="text-black2 cursor-pointer text-bodySR">{label}</label>
    </div>
  );
};

export default CheckboxWithLabel;
